import { render, staticRenderFns } from "./mail-log-view.vue?vue&type=template&id=707f075b&"
import script from "./mail-log-view.vue?vue&type=script&lang=js&"
export * from "./mail-log-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports